export default __webpack_public_path__ + "static/twitter-light-a1dcecc72844e59e548ce0f58a996c96.png";